import { Box, Stack, Typography } from '@mui/material'
import { Icons } from 'utoniq-ui'

import {
  Maybe,
  SkuTagFragment,
  SkuTypeFragment,
  UserPaymentType,
} from '@/clients/utoniq-core/schema'
import { SkuTag } from '@/components/organisms'
import { styleSets } from '@/components/styles'
import { useTranslation } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'

type SkuTypeCellProps = {
  value?: string
  onSelect: (sku?: SkuTagFragment) => void
  skuSettings?: Maybe<SkuTypeFragment>
  paymentType?: Maybe<UserPaymentType>
  issuedNumber?: number | null
  isResaleEnable?: boolean | null
  disabled?: boolean
  hasAlertText?: boolean
}
export const SkuType: Organism<SkuTypeCellProps> = ({
  value,
  onSelect,
  skuSettings,
  paymentType,
  issuedNumber,
  isResaleEnable,
  disabled,
  hasAlertText,
}) => {
  const { t } = useTranslation('storeItemDetail')

  if (!skuSettings?.units.length) {
    return null
  }

  return (
    <OrganismFrame sx={{ pb: 1 }}>
      {hasAlertText && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            pb: 2,
          }}
        >
          <Icons.Error fontSize="small" color="error" />
          <Typography
            variant="caption"
            color="error.main"
            sx={{ textAlign: 'center' }}
          >
            {t('types')}
          </Typography>
        </Box>
      )}
      <Typography variant="h6" color={'text.secondary'}>
        {t('types')}
      </Typography>
      <Stack
        flexWrap="wrap"
        sx={{
          py: 2,
          overflowY: 'auto',
          ...styleSets.hideScrollbar(),
        }}
      >
        <Stack spacing={2} direction="row">
          {skuSettings.units.map(skuUnit => (
            <SkuTag
              key={skuUnit.id}
              skuUnit={skuUnit}
              active={skuUnit.id === value}
              disabled={disabled}
              paymentType={paymentType}
              issuedNumber={issuedNumber}
              isResaleEnable={isResaleEnable}
              onClick={() =>
                onSelect(skuUnit.id === value ? undefined : skuUnit)
              }
            />
          ))}
        </Stack>
      </Stack>
    </OrganismFrame>
  )
}
